import { render, staticRenderFns } from "./StockTypeList.vue?vue&type=template&id=ba0b44a0&scoped=true"
import script from "./StockTypeList.vue?vue&type=script&lang=js"
export * from "./StockTypeList.vue?vue&type=script&lang=js"
import style0 from "./StockTypeList.vue?vue&type=style&index=0&id=ba0b44a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0b44a0",
  null
  
)

export default component.exports